import React, { useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid} from 'recharts';
import dayjs from 'dayjs';

const PtgcVolumePlsPriceChart = ({fullData}) => {
  const timeframes = {'1W': 7, '1M': 30, '3M': 90, '6M': 180, '1Y': 365, 'ALL': null };
  const [timeframe, setTimeframe] = useState('3M');

  const getChartData = () => {
      let filtered = timeframes[timeframe] === null ? fullData : fullData.filter(d => dayjs(d.date).isAfter(dayjs().subtract(timeframes[timeframe], 'day')));
          filtered = filtered.sort((a, b) => new Date(a.date) - new Date(b.date));

      if (filtered.length === 0) return [];

      const basePTGC = filtered[0].PTGC;
      const basePLS = filtered[0].PLS;
      return filtered.map(d => ({...d, PTGC: ((d.PTGC - basePTGC) / basePTGC) * 100, PLS: ((d.PLS - basePLS) / basePLS) * 100, }));
  };

  const chartData = getChartData();

  return (
   <div style={{
      width: "100%",
      backgroundColor: "#111",
      borderRadius: 12,
      padding: 10,
      color: "#fff",
      gap: 10,
      alignItems: "center",
      position: "relative",
      overflow: "hidden"
    }}>
      <div className='d-flex justify-content-end'>
        <div className="rTabs d-flex justify-content-end flex-wrap gap-2 mb-3">
          {Object.keys(timeframes).map(tf => (
            <button
              key={tf}
              onClick={() => setTimeframe(tf)}
              style={{
                padding: '6px 12px',
                background: timeframe === tf
                  ? 'linear-gradient(94.35deg, #F8F192 0.05%, #E3D578 26.62%, #B18D38 56.99%, #9D721F 98.73%)'
                  : '',
                color: '#fff',
                border: 'none',
                borderRadius: 15,
                cursor: 'pointer',
                transition: '0.3s'
              }}
            >
              {tf}
            </button>
          ))}
        </div>
      </div>

      <ResponsiveContainer width="100%" height={500}>
        <AreaChart data={chartData} margin={{ left: 0, right: 0 }}>
          <defs>
            <linearGradient id="colorPTGC" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FFD700" stopOpacity={0.6} />
              <stop offset="100%" stopColor="#121212" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="colorPLS" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FFB800" stopOpacity={0.6} />
              <stop offset="100%" stopColor="#121212" stopOpacity={0} />
            </linearGradient>
          </defs>

          {/* Add Cartesian Grid */}
          <CartesianGrid stroke="#333" strokeDasharray="3 3" />
          <XAxis dataKey="date" tick={{ fill: '#ccc', fontSize: 12 }} tickFormatter={date => dayjs(date).format('DD MMM, YYYY')}/>
          <YAxis yAxisId="PTGC" label={{ value: 'PTGC', angle: -90, position: 'insideLeft', fill: '#ccc', offset: 20 }} tick={{ fill: '#ccc', fontSize: 12 }} orientation="left"/>
          <YAxis yAxisId="PLS" label={{ value: 'PLS', angle: -90, position: 'insideRight', fill: '#ccc', offset: 20 }} tick={{ fill: '#ccc', fontSize: 12 }} orientation="right"/>

          <Tooltip contentStyle={{ backgroundColor: '#333', border: 'none' }} labelStyle={{ color: '#fff' }}
            formatter={(value, name) => {
              const formatted = parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })+'%';
              if (name === 'PTGC') return [formatted, 'PTGC Volume: '];
              if (name === 'PLS') return [formatted, 'PLS Price: '];
              return [formatted, name];
            }}
            labelFormatter={label => `Date: ${dayjs(label).format('DD MMM, YYYY')}`}
          />
          <Area type="monotone" dataKey="PTGC" stroke="#FFD700" fill="url(#colorPTGC)" fillOpacity={1} yAxisId="PTGC"/>
          <Area type="monotone" dataKey="PLS" stroke="#FFB800" fill="url(#colorPLS)" fillOpacity={1} yAxisId="PLS"/>
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PtgcVolumePlsPriceChart;
